<template>
  <div class="my_businees_publish">

    <div class="search">
      <el-form :inline="true" class="demo-form-inline" size="small">
        <el-form-item :label="$t('参展活动')">
            <el-select v-model="search.activeId" placeholder="" filterable clearable>
              <el-option v-for="item in activeAll" 
              :key="item.name" 
              :label="item.name" 
              :value="item.id">
            </el-option>
            </el-select>
        </el-form-item>
        <el-form-item :label="$t('届次')">
          <el-select v-model="search.year" placeholder="" filterable clearable>
            <el-option v-for="item in years" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>

        <el-button type="primary" @click="onSubmit" size="small">{{ $t('查询')}}</el-button>
        <el-button @click="handleReset" size="small">{{ $t('我要参展')}}</el-button>
      </el-form>
    </div>
    <!-- 内容 -->
    <div class="table">
      <el-table :data="Activelist" border style="width: 100%">
        <el-table-column :label="$t('活动名称')" width="200">
          <template slot-scope="scope">
            <p>{{ scope.row.activeName }}</p>
          </template>
        </el-table-column>
        <el-table-column :label="$t('活动时间')">
          <template slot-scope="scope" width="200">
            <span>{{ scope.row.activeStartDate | formatTime }}</span>-<span>{{ scope.row.activeDEndDate | formatTime
              }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('参展状态')" width="80">
          <template slot-scope="scope">
           {{ scope.row.status || $t('未参展') }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('身份')" width="80">
          <template slot-scope="scope">
            {{ scope.row.userType }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('展位')" width="80">
          <template slot-scope="scope">
            {{ scope.row.booth || '无' }}
          </template>
        </el-table-column>
      </el-table>

   

    </div>

  </div>
</template>
<script>
import { getMyActivelist, getALLActivelist } from '../../../apis/my_businees_publish'
export default {
  data() {
    return {
   
      total: 0,
      currentPage: 1,
      pageSize: 2,
      pageCount: 0,
      Activelist: [],
      search:{
        activeId:'',
        year:''
      },
      activeAll:[],
      years: this.yearData()


    }
  },
  filters: {
    formatTime(timestamp) {
      return timestamp ? new Date(timestamp).format('yyyy-MM-dd hh:mm:ss') : '--';
    },
  },
  activated() {
  },
  created() {
    this.busineesList()
    this.getData()
  },

  methods: {
    async busineesList(body = {
      "activeId": '',
      "year": '',
    }) {
      // 我的活动
      const my_active = await getMyActivelist(body)
      this.Activelist = my_active.data
    },
    async getData(){
     // 全部活动
     const all_active = await getALLActivelist()
     this.activeAll = all_active.data
     console.log(this.years)
    },
    onSubmit() {
      //console.log(this.search)
      this.handleSearch();
    },
    // 查询数据
    handleSearch(currentPage = 1) {
      this.currentPage = currentPage;
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.search,
          currentPage,
        },
      });
      this.busineesList({ ...this.search, currentPage });
    },
    // 时间
    yearData(){
        const temp =[]
        const currentYear = new Date().getFullYear();
        // 生成从 2020 到当前年份的年份选项
        for (let year = 2020; year <= currentYear; year++) {
          temp.push(year)
        }
          return temp
    }


  }
}
</script>
<style lang="scss" scoped>
/* pageFullScreen在index.css */
.my_businees_publish {
  padding:20px 10px
}
</style>
